// Parses the admin-authored welcome message: the only supported markup is
// [Text](/path), everything else stays plain text. No react-markdown here on
// purpose — the surface is a single, security-relevant pattern (one field,
// rendered to every user), so an explicit, auditable parser beats configuring
// a general-purpose renderer down to "links only".
const LINK_PATTERN = /\[([^\]]+)\]\((\/(?![/\\])[^)\s\\]+)\)/g;

export type HintSegment = { type: "text"; value: string } | { type: "link"; text: string; href: string };

export function parseHintText(text: string): HintSegment[] {
  const segments: HintSegment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(LINK_PATTERN)) {
    const [full, linkText, href] = match;
    const index = match.index ?? 0;
    if (index > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, index) });
    }
    segments.push({ type: "link", text: linkText!, href: href! });
    lastIndex = index + full.length;
  }
  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) });
  }
  return segments;
}
